import { TaskImportFileModel } from "./TaskImportFileModel";

export class TaskImportDataModel {
  /**Номер задачи weeek */
  WeeekTaskId?: number;
  /**Номер рабочей области weeek */
  WeeekWorkspaceId?: number;
  /**Название задачи */
  Name!: string;
  /**Описание задачи */
  Description!: string;
  /**Статус */
  StatusId!: number;
  /**Тип задачи */
  TypeId!: string;
  /**Приортите */
  PriorityId!: number;
  /**Уровень сложности */
  DifficultyId!: string;
  /**Список тегов */
  Tags: Array<number> = [];
  /**Файлы */
  Files: Array<TaskImportFileModel> = [];

  constructor(obj?: Partial<TaskImportDataModel>) {
    Object.assign(this, obj);
  }
}
